import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Motion, Wrapper } from 'Components/UI'
import { Button, Text } from 'Components/UI/_Legacy'
import { KEY_FAQ_ITEMS } from 'Data/faq'

import { ROOT } from 'Constants/Paths'

import Category from './category'
import KeyQuestions from './keyQuestions'
import { Container, Content, Row } from './styles'

function Hero({ data }) {
  const renderFaq = useMemo(
    () =>
      data
        .sort((a, b) => a.order - b.order)
        .map(entity => (
          <Motion key={entity?.id}>
            <Category category={entity} />
          </Motion>
        )),
    [data],
  )

  return (
    <Container>
      <Wrapper>
        <Content>
          <Row mb={[32, 32, 64]}>
            <Text as="h1" medium mt={[3, 3, 0]} title>
              Frequently Asked Questions
            </Text>

            <Button.Link href={ROOT} outline secondary>
              Back to homepage
            </Button.Link>
          </Row>

          <KeyQuestions items={KEY_FAQ_ITEMS} />

          {renderFaq}
        </Content>
      </Wrapper>
    </Container>
  )
}

Hero.defaultProps = {
  data: {},
}

Hero.propTypes = {
  data: PropTypes.object,
}

export default Hero
